import { useMutation } from '@apollo/client/react';
import { useError } from 'contexts/error';
import { FormattedMessage } from 'react-intl';
import { ModalTypography } from 'components/styles_components/typography';
import ExecuteMutation from 'mutations/inspection/execute';
import Form from 'components/inspection/modal/execute/execute_form';
import InspectionResult from 'utils/inspection_result';
import { nextDueDate } from 'utils/inspection';

const IR = InspectionResult();

const Execute = ({ inspection, handleClose, onSuccess }) => {
  const setError = useError();
  const [executeInspection, { loading }] = useMutation(ExecuteMutation, {
    onCompleted: (data) => {
      onSuccess(data.executeInspection.inspectionResult);
    },
    onError: () => {
      setError('error.inspection.execute');
    },
  });
  const executeValues = (values) => {
    return {
      ...values,
      inspectionFields: values.inspectionFields.map((field) => ({
        id: field.id,
        value: field.value || false,
      })),
    };
  };

  return (
    <>
      <ModalTypography variant="h5" align="center">
        <FormattedMessage id="header.inspection.execute" />
      </ModalTypography>
      <Form
        initialValues={{
          notes: undefined,
          doneAt: new Date(),
          dueDate: nextDueDate(new Date(), inspection.periodCycle, inspection.periodNumber),
          result: IR.SUCCESS,
          id: inspection.id,
          inspectionFields: inspection.inspectionFields,
        }}
        periodCycle={inspection.periodCycle}
        periodNumber={inspection.periodNumber}
        processing={loading}
        onSubmit={(values) => executeInspection({ variables: executeValues(values) })}
        onCancel={handleClose}
      />
    </>
  );
};

export default Execute;
